import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    BOOK_APPOINTMENT,
    bookAppointmentSuccess,
    bookAppointmentFail
} from '../action/bookAppointmentAction'

// api 
import bookAppointmentApi from '../api/bookAppointmentApi'

export function* bookAppointmentSaga(action) {
    try {
        const response = yield call(() => bookAppointmentApi(action.params))
        if (response.data.status === 1) {
            yield put(bookAppointmentSuccess(response, action))
        } else {
            yield put(bookAppointmentFail(response, action))
        }
    } catch (e) {
        yield put(bookAppointmentFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(BOOK_APPOINTMENT, bookAppointmentSaga)
}